import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { MarkItViewApi } from "../../../../Apis/Apis";
import { CommodityManagementSiteModel, CompanyModel } from "../../../../Generated/Mark-It-View-Api";
import { useLoadingState } from "../../../../Hooks";
import { StoneXRow } from "../../../StoneX";
import { StoneXAutocomplete, StoneXModal, StoneXTextField } from "../../../StoneXMui";

interface UpdateSiteProps {
  open: boolean;
  onClose: () => void;
  onSave: (site: CommodityManagementSiteModel) => void;
  site?: CommodityManagementSiteModel;
}

export function UpdateSiteModal(props: UpdateSiteProps) {

  const { open, onClose, onSave, site } = props;

  const [siteName, setSiteName] = useState<string>('');
  const [companies, setCompanies] = useState<CompanyModel[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<CompanyModel | null>(null);
  const saveSiteLoadingState = useLoadingState();
  const companiesLoadingState = useLoadingState();

  useEffect(() => {
    if (!open) {
      return;
    }
    MarkItViewApi.listCompanies(companiesLoadingState.setLoadingState).then((res) => {
      setCompanies(res.data.rows ?? []);
    });
  }, [open]);

  useEffect(() => {
    setSiteName(site?.siteName ?? '');
    setSelectedCompany(site?.company ?? null);
  }, [site]);

  const actionLabel = props.site ? 'Update' : 'Add';
  const canSubmit = siteName.trim().length > 0 && selectedCompany !== null;

  function save() {
    if (!selectedCompany) {
      return;
    }

    if (site?.siteGuid) {
      MarkItViewApi.updateCommodityManagementSite(saveSiteLoadingState.setLoadingState, site.siteGuid, siteName, selectedCompany.companyGuid, []).then((res) => {
        onSave(res.data.site!);
        onClose();
      });
    }
    else {
      MarkItViewApi.addCommodityManagementSite(saveSiteLoadingState.setLoadingState, siteName, selectedCompany.companyGuid).then((res) => {
        onSave(res.data.site!);
        onClose();
      });
    }
  }

  return (
    <StoneXModal header={actionLabel + ' Site'} open={open} onClose={onClose}>
      <StoneXRow>
        <StoneXTextField label="Name" maxLength={100} value={siteName} onUpdate={(x: string) => setSiteName(x)} />
        <StoneXAutocomplete<CompanyModel>
          label="Company"
          showRequired
          options={companies}
          value={selectedCompany}
          getOptionLabel={(c) => c.name}
          getOptionKey={(c) => c.companyGuid}
          isOptionEqualToValue={(a, b) => a.companyGuid === b.companyGuid}
          onUpdate={(value) => setSelectedCompany(value)}
          loading={companiesLoadingState.isLoading}
        />
      </StoneXRow>

      <StoneXRow justify="end">
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={save} disabled={!canSubmit}>{actionLabel + ' Site'}</Button>
      </StoneXRow>
    </StoneXModal>
  );
}
